import TermsItem from './TermsItem';
import Text from '../../common/component/Text';
import {ITermsItem} from '../type';

interface IProps {
  descText?: string;
  termsList: ITermsItem[];
  termsCheckedObj: {[key: number]: boolean};
  onChangeItem: (id: number) => void;
}

export default function IdVerificationModalDesc({
  descText,
  termsList,
  termsCheckedObj,
  onChangeItem,
}: IProps) {
  return (
    <div>
      {descText && <Text className="s13-regular-grey08">{descText}</Text>}
      {termsList.map((item, index) => (
        <div
          key={item.id}
          className={cn({
            'mt-18': !!index,
            'mt-22': !index && descText,
            'mt-12': !index && !descText,
          })}
        >
          <TermsItem
            item={item}
            checked={termsCheckedObj[item.id] || false}
            isModal={true}
            onChange={onChangeItem}
          />
        </div>
      ))}
    </div>
  );
}
